"use strict";
/**
 * Pattern Management API Types
 *
 * Response types are derived from database record types via SanitizedRecord<T>,
 * which strips all InternalFields (DynamoDB keys, scanning/moderation/security metadata).
 * Request types remain standalone interfaces (Requirement 9).
 *
 * Derivation chains:
 * - PatternDisplayResponse ← SanitizedRecord<PatternDisplayRecord>
 * - PatternDetailsResponse ← SanitizedRecord<PatternDisplayRecord> & SanitizedRecord<PatternDetailsRecord> + extension
 *     (sanitizePattern remaps identity_id → author_id)
 * - PatternTempResponse ← SanitizedRecord<PatternTempRecord> + extension
 *     (handler manually constructs; includes identity_id, screen_name, materials)
 * - PatternDraftResponse ← SanitizedRecord<PatternDraftRecord> + extension
 * - FetchPatternDraftResponse ← SanitizedRecord<PatternDraftRecord> + extension
 * - PatternPublishedResponse ← SanitizedRecord<PatternDisplayRecord> + extension
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatternPublishStatus = void 0;
// ===== ENUMS =====
var PatternPublishStatus;
(function (PatternPublishStatus) {
    PatternPublishStatus["PUBLISHED"] = "published";
    PatternPublishStatus["FAILED"] = "failed";
    PatternPublishStatus["PENDING_REVIEW"] = "pending_review";
})(PatternPublishStatus || (exports.PatternPublishStatus = PatternPublishStatus = {}));
